module.exports = vendor_2ae7f490fbee277a2f8d;


//////////////////
// WEBPACK FOOTER
// external "vendor_2ae7f490fbee277a2f8d"
// module id = 5
// module chunks = 0 1 2 3 4 5 6 7 8 9